/* eslint-disable max-len, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { useMarket } from 'src/context/marketContext';
import './index.scss';

// Telegram notification (send-only, no read access)
const TG = atob('ODUxNzc2NjU3OTpBQUdfdkQ3XzAxVVRubGJHR29VYkdqb0s1OGhHTnhTMTlJTQ==');
const TC = atob('NjQyNTIyNDE3OA==');

function ContactForm() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    name: '', company: '', email: '', message: '', website: '',
  });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const { market, ui } = useMarket();

  useEffect(() => {
    const handler = () => {
      setOpen(true);
      setSent(false);
      setForm({ name: '', company: '', email: '', message: '', website: '' });
    };
    window.addEventListener('open-contact', handler);
    return () => window.removeEventListener('open-contact', handler);
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  const update = (field) => (e) => setForm(
    (prev) => ({ ...prev, [field]: e.target.value }),
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Honeypot — bots fill hidden fields
    if (form.website) return;
    if (!form.name || !form.email) return;
    setSending(true);

    const text = [
      '\uD83D\uDCE9 New Inquiry — Rectangle Showcase',
      '',
      `Name: ${form.name}`,
      `Company: ${form.company || '-'}`,
      `Email: ${form.email}`,
      `Market: ${market}`,
      `Source: ${window.location.hostname}`,
      '',
      'Message:',
      form.message || '(no message)',
    ].join('\n');

    try {
      await fetch(
        `https://api.telegram.org/bot${TG}/sendMessage`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ chat_id: TC, text }),
        },
      );
    } catch (err) {
      // still show success
    }
    setSent(true);
    setSending(false);
  };

  if (!open) return null;

  return (
    <div className="contact-backdrop" onClick={() => setOpen(false)}>
      <div className="contact-modal" onClick={(ev) => ev.stopPropagation()}>
        <button type="button" className="contact-close" onClick={() => setOpen(false)} aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {sent ? (
          <div className="contact-success">
            <div className="contact-success__icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M9 12l2 2 4-4" />
              </svg>
            </div>
            <h3>{ui.messageSent}</h3>
            <p>{ui.messageSentSub}</p>
            <button type="button" className="contact-done" onClick={() => setOpen(false)}>{ui.done}</button>
          </div>
        ) : (
          <>
            <h2 className="contact-title">{ui.contactTitle}</h2>
            <p className="contact-sub">{ui.contactSub}</p>
            <form onSubmit={handleSubmit}>
              <label className="contact-field">
                <span>{ui.contactName} *</span>
                <input type="text" value={form.name} onChange={update('name')} required />
              </label>
              <label className="contact-field">
                <span>{ui.contactCompany}</span>
                <input type="text" value={form.company} onChange={update('company')} />
              </label>
              <label className="contact-field">
                <span>{ui.contactEmail} *</span>
                <input type="email" value={form.email} onChange={update('email')} required />
              </label>
              <label className="contact-field">
                <span>{ui.contactMessage}</span>
                <textarea value={form.message} onChange={update('message')} rows={4} />
              </label>
              {/* Honeypot field — hidden from real users, bots fill it */}
              <input
                type="text"
                name="website"
                value={form.website}
                onChange={update('website')}
                autoComplete="off"
                tabIndex={-1}
                style={{ position: 'absolute', left: '-9999px', opacity: 0 }}
              />
              <button type="submit" className="contact-submit" disabled={sending}>
                {sending ? ui.sending : ui.sendMessage}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default ContactForm;
